import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../api";
import Reseller, { SalesStatistics } from "./Reseller";

class ResellerStore {
  reseller?: Reseller = undefined;
  topResellers?: Reseller[] = undefined;
  resellerSalesData?: SalesStatistics[] = undefined;

  constructor() {
    console.warn(
      "Deprecation Warning: The legacy 'ResellerStore' is in use. Please migrate to RTK Query as outlined in CONTRIBUTING.md."
    );
    makeObservable(this, {
      reseller: observable,
      topResellers: observable,
      resellerSalesData: observable,
      getReseller: action.bound,
      getResellers: action.bound,
      insertQualificationId: action.bound,
      removeQualificationId: action.bound,
      getResellerSalesData: action.bound,
    });
  }

  async getReseller(applicationId: string, resellerId: string) {
    try {
      if (this.reseller?.resellerId !== resellerId) {
        this.reseller = undefined;
      }

      const resellerWithSpecification = await api.resellers.retrieveReseller(applicationId, resellerId, true);
      const mappedResellerWithSpecification = Reseller.convertFrom(resellerWithSpecification);
      runInAction(() => { this.reseller = mappedResellerWithSpecification; });
    } catch (e) {
      console.error(e);
    }
  }

  async getResellers(applicationId: string) {
    try {
      const resellers = await api.resellers.retrieveResellers(applicationId);
      const convertedTopResellers = resellers.map(Reseller.convertFrom);

      runInAction(() => {
        this.topResellers = convertedTopResellers;
      });
    } catch (e) {
      console.error(e);
    }
  }

  async insertQualificationId(applicationId: string, resellerId: string, qualificationId: string): Promise<boolean> {
    try {
      return await api.resellers.insertQualificationId(applicationId, resellerId, qualificationId);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async removeQualificationId(applicationId: string, resellerId: string): Promise<boolean> {
    try {
      return await api.resellers.removeQualificationId(applicationId, resellerId);
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async getResellerSalesData(applicationId: string, resellerId: string) {
    try {
      const today = new Date();
      const fiveYearsAgo = new Date(today);
      fiveYearsAgo.setFullYear(today.getFullYear() - 5);
      const todayString = today.toISOString();
      const fiveYearsAgoString = fiveYearsAgo.toISOString();

      const stats = await api.resellers.getResellerSalesStatistics(applicationId, resellerId, fiveYearsAgoString, todayString);
      runInAction(() => { this.resellerSalesData = stats.map(SalesStatistics.convertFrom); });
    } catch (e) {
      console.error(e);
      return [];
    }
  }
}

export default ResellerStore;
